import styled from 'styled-components';
import Button from '@material-ui/core/Button';


export const StyledButton = styled(Button)`
  // color: #555;

  padding: 4px 10px;
  border: 1px solid #777;
  font-family: 'Kanit';
  font-size: 16px;
  &:hover {
    color: #fff;
    background-color: #033375;
  }
`;

export const StyledSubmitButton = styled(Button)`
  color: #fff;
  padding: 8px 10px;
  border: 1px solid #777;
  font-family: 'Kanit';
  font-size: 16px;
  background-color: #033375;
  font-weight: 300;
  &:hover {
    color: #000;
    background-color: #fff;
  }
`;

// icon button
export const StyledIconButton = styled(Button)`
  color: #555;
  padding: 0px 0px;
  margin: 8px -10px;
  font-family: 'Kanit';
  font-size: 14px;
  &:hover {
    color: #fff;
  }
`;

export const StyledFormButton = styled(Button)`
  color: #555;
  padding: 0px 10px;
  border: 1px solid #ccc;
  font-family: 'Kanit';
  font-size: 14px;
  &:hover {
    color: #fff;
    background-color: #033375;
  }
`;

export const StyledOutlineButton = styled(Button)`
  color: #000;
  padding: 5px 25px;
  border: 1px solid #ccc;
  border-radius: 30px;
  font-family: 'Kanit';
  font-size: 14px;
  text-transform: lowercase;
  &:hover {
    color: #fff;
    background-color: #033375;
  }
`;

// border shadow
export const StyledBorderButton = styled(Button)`
  color: #555;
  padding: 0px 5px;
  font-size: 14px;
  font-family: 'Kanit';
  border: 1px solid #ddd;
`;

// มุมมอง
export const StyledViewButton = styled(StyledButton)`
  color: #555;
  padding: 0px 20px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 30px;
  @media (min-width: 375px){
    font-size: 12px;
  }
`;

export const FlexButton = styled(StyledButton)`
  color: #555;
  padding: 0px 10px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 30px;
  @media (min-width: 375px){
    font-size: 12px;
  }
`;

// แสดงผล
export const StyledShowButton = styled(StyledButton)`
  color: $fff;
  padding: 0px 50px;
  border: 1px solid #ccc;
`;

// แผนที่
export const StyledLinkButton = styled(StyledButton)`
  color: $fff;
  padding: 2px 15px;
  border: 1px solid #555;
  border-radius: 30px;
  background: rgb(255 255 255 / 52%);
  font-family: 'Kanit';
`;

export const StyledSidebarButton = styled(Button)`
  color: $fff;
  min-width: 0px;

  border-radius: 50px;
  font-family: 'Kanit';

  padding: 2px;
  width: 32px;
  height: 32px;
  &:hover {
    border: 4px solid #021e33;
    background: #021e33;
  }
  
`;
// export default function StyledComponents() {
//   return (
//     <div>
//       <StyledButton>Customized</StyledButton>
//       {/* <TomatoButton>Customized</TomatoButton> */}
//     </div>
//   );
// }

export const StyledBtnLinkWebsite = styled(Button)`

  min-width: 0px;
  border-radius: 8px;
  font-family: 'Kanit';
  padding: 10px  20px;
  height: 32px;
  background: #E5E3DF;
  font-weight: 300;
  margin-right: 20px;
  margin-top: 10px;
  text-transform: lowercase;
  &:hover {
    color: #fff;
    background: #033375;
  }
  
`;